<template>
  <div>
    <headEnterprise></headEnterprise>
    <banner :banner="banner"></banner>
		<enterTitle></enterTitle>
    <div class="w80 mb-30 mt-30">
      <el-container>
        <el-aside width="330px">
          <base-info @onCollection="goCollection(7)"></base-info>
          <div class="saide_middle">
            <div class="saide_mater">
              <p>产品分类</p>
            </div>
            <div class="saide_tree">
              <el-tree
              :data="data"
              show-checkbox
              node-key="id"
              ref="tree"
              default-expand-all
              :props="defaultProps"> </el-tree>
            </div>
          </div>
        </el-aside>
        <el-main>
          <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
          <div class="mt-30">
            <div class="supply_mter">
              <div class="picture"  @click="toDetail(item)" v-for="(item, index) in list" :key="index">
              <div class="picture_box">
                <img :src="item.cover" alt="" />
              </div>
                <p>{{ item.title }}</p>
              </div>
            </div>

            <!--分页-->
            <Pagination
              v-show="total > 0"
              :total="total"
              :page.sync="listQuery.curPage"
              :limit.sync="listQuery.limit"
              @pageChange="pageChange"
            ></Pagination>

		   <!--显示没有数据-->
		   <div style="margin-top:20%;">
			   <notList :notCode="notCode"></notList>
		   </div>

          </div>
        </el-main>
      </el-container>
    </div>
    <!-- <footCom></footCom> -->
  </div>
</template>
<script>

import { suppType} from "@/api/company";
import {getProduct} from "@/api/information.js"
import footCom from "../../common/footCom";
import headEnterprise from "../../common/headEnterprise";
import banner from "../../common/banner";
import contTitle from "../../common/contTitle";
import baseInfo from "@/components/companyintroCard";
import Pagination from "../../components/Pagination";
import enterTitle from '../../common/enterTitle'
import notList from '../../common/notList'
import{addCollection} from "@/api/coment"
import { getToken } from "@/utils/auth";
export default {
  components: {
    footCom,
    headEnterprise,
    banner,
    contTitle,
    baseInfo,
    Pagination,
    enterTitle,
    notList
  },
  data() {
    return {
      contTitle: "供应产品",
      banner: {
        title: "供应信息",
        isShow: false,
        isColor: true,
        type:'',
        usertype:'',
        companytype:'',
        bannerUrl:""
      },
      obj:{
        title: "供应信息",
      },
      data:[],
      defaultProps:{
        children: 'children',
        label: 'name'
      },
      list: [],
      listQuery: {
        curPage: 1,
        limit: 9,
      },
      total: 0, //总条数
      id:'',
      notCode:false
    };
  },
  created() {
    this.id = sessionStorage.getItem('corporateId');
    this.$store.dispatch("company/getBaseInfo");
    if(this.id){
       this.getList();
	     this.getSuppType();
    }
    if(this.$store.state.user.userInfo != null){
       this.banner.usertype = this.$store.state.user.userInfo.type;
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.companyInfo;
    }
  },
  watch: {
    userInfo: {
      handler: function (val, oldVal) {
        if (val.userId) {
          this.banner.bannerUrl = val.banner;
        }
      },
      immediate: true,
    },
  },
  methods: {
    toDetail(item){
      this.$router.push({
        path:"/supply_detail",
        query:{id:item.id}
      })
    },
    //列表
    getList() {
      getProduct({
		 ...this.listQuery,
		 userid:this.id
	  }).then((res) => {
      if (res.code == 0) {
        this.list = res.page.list;
        this.total = res.page.totalCount;
        this.list.length == 0 ? this.notCode = true: this.notCode = false;
      }
     }).catch((err) => {});
    },
    //分页
    pageChange(item) {
      this.listQuery["curPage"] = item.page;
      this.listQuery["limit"] = item.limit;
      this.getList();
    },
    //收藏
    goCollection(goodsType){
      let params ={
        goodsId:this.id,
        goodsType:goodsType
      }
      addCollection(params).then((res)=>{
        if(res.code ==0){
          this.$message({
            message: '收藏成功！',
            type: 'success'
          });
        }
      }).catch((err)=>{})
    },
	//获取产品分类
	getSuppType(){
	  let params = {user_id:this.id};
	  suppType({params}).then((res)=>{
		if(res.code == 0){
		   this.data = res.data;
		}
	  }).catch((err)=>{})
	}
  },
};
</script>
<style scoped>
.el-aside {
  height: 930px;
}
.mt-20 {
  margin-top: 20px;
}
.supply_mter{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.supply_mter::after{
  content: '';
  width: 32%;
}
.picture {
  width: 32%;
  text-align: center;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  margin-bottom: 20px;
  border: 1px solid #EBEBEB;
}
.picture_box{
  overflow: hidden;
  margin-right: 20px;
  width: 100%;
  height: 143px;
}
.picture_box img {
  width: 100%;
  height: 100%;
  transition: all 0.5s;
}
.picture_box img:hover{
  cursor: pointer;
 transform: scale(1.1);
}
.picture p {
  margin: 5px 0px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-pagination {
  margin-top: 40px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #3bae30 !important;
  color: #fff;
}

.el-aside {
  background: white;
  height: auto;
  /* border: 1px solid red; */
}
.saide_middle{
	margin-top: 20px;
	height: 300px;
	background: #F8F8F8;
	border-top: 2px solid #99CF2A;
}
.saide_mater {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 1px dashed #e1e1e1;
}
.saide_mater p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  padding: 10px;
}
.saide_mater span {
  cursor: pointer;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.el-tree {
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/view/corporate/corporate_supply_all.vue